<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
import { setDict } from "@/utils/dict"
import { detectDeviceType } from '@/utils'
import { Toast } from 'vant'
import DingTalk from '@/config/DingTalk'
import Tabbar from '@/components/Tabbar'
import { authUrl } from '@/config/Settings'
export default {
  components: {
    Tabbar,
  },
  data() {
    return {
      activeTab: 0,
      showUserPanel: false,
      hideNavbarPageList: [
        'customerList', 'visitList', 'orderList', 'm_countBoard',
        'dyBoard2','dyBoard', 'dyBoardConf', 'tmBoard', 'tmBoard2', 'tmBoardConf',
        'count_datecheck', 'delivery_board', 'product_task'
      ],
    }
  },
  computed: {
    isLogout() {
      // 检查token是否存在，如果不存在则认为已登出
      return !this.$store.getters.token;
    },
    isTabbar() {
      return ['home', 'customerList', 'visitList', 'orderList','m_countBoard'].includes(this.$route.name)
    },
    hideNavbar() {
      return !this.notInDingTalk 
        || this.hideNavbarPageList.includes(this.$route.name)
        || (this.$route.name === 'm_dateUpload' && detectDeviceType() === 'Mobile')
    },
  }, 
  created() {
    // 检查用户登录状态
    const token = this.$store.getters.token
    if (token) {
      // 如果有token但没有用户信息，尝试获取用户信息
      const hasName = this.$store.getters.name && this.$store.getters.name.length > 0
      if (!hasName) {
        this.$store.dispatch('user/getInfo').catch(() => {
          // 获取失败，清除token
          this.$store.dispatch('user/resetToken')
        })
      }
      
      // 获取未读消息数量
      this.$store.dispatch('user/getUnreadMessageCount').catch(() => {
        // 获取失败，不处理
        console.log('获取未读消息数量失败');
      });
    }
    
    // 在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store')))
      )
    }
    // 在页面刷新时将vuex里的信息保存到localStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })    
  },
  mounted() { 
    //PC端 使右键和复制失效
    document.oncontextmenu = new Function("event.returnValue=false");
    document.onselectstart = new Function("event.returnValue=false");
    //ios
    document.oncontextmenu = function (e) {
        e.preventDefault();
    };
    document.onselectstart = function (e) {
        e.preventDefault();
    };
    //安卓
    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });
  },
  watch: {
    isLogout(val) {
      if(val) {
        this.$router.push({path: '/login'})
      }
    },
  },
  methods: {
    refresh() {
      window.location.reload()
    },
    async logout() {
      await this.$store.dispatch('user/logout')  
      this.$router.push({path: '/login'})
    },    
    // 钉钉登陆
    ddLogin() {
      // 钉钉外的浏览器内不执行钉钉自动登录
      if (dd.env.platform === 'notInDingTalk') return
      const _this = this
      dd.ready(function() {
        dd.runtime.permission.requestAuthCode({
          corpId: DingTalk.corpId,
          onSuccess: function(result) {
            Toast.loading({
              message: '获取钉钉信息自动登录',
              forbidClick: true,
            })       
            // 调用接口获取 token
            _this.$http.get(`/oa/oa/oaLogin?code=${result.code}`).then(res => {
              _this.$store.dispatch('ddLogin', res.data).then(() => {
                Toast.success('登录成功')
                // 获取用户信息
                _this.$store.dispatch('GetInfo')
                _this.$router.push({path: '/'})
                // 获取字典数据存储到 store 中
                setDict()
              }).catch(err => {
                Toast('error 钉钉登录失败：'+JSON.stringify(err))
              })
            })
          },
          onFail : function(err) {}
        })
      })      
    },
    // jsapi 鉴权配置
    jsapiAuthorization() {
      // dd.config中所有的参数必须直接来自服务端，不能直接在前端定义。
      // 一个页面只需要调用一次dd.config即可，重复调用会复用第一次调用的参数，
      // 单页应用（SPA）的router切换视为同一个页面。      

      // if (dd.env.platform === 'notInDingTalk') return

      this.$http.post('/oa/oa/authorizeJsApi', {url: location.href}).then(res => {
        console.log('jsapi 鉴权：：：：', res)
        if(res.code !== 200) {
          return Toast(res.msg)
        }
        const {agentId, corpId, nonceStr, signature, timeStamp} = res.data
        dd.config({
          agentId, // 必填，微应用ID
          corpId,//必填，企业ID
          timeStamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，自定义固定字符串。
          signature, // 必填，签名
          type: 0,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList : [
            'device.geolocation.get', // 获取当前地理位置信息（单次定位）
            'device.geolocation.start', // 连续获取当前地理位置信息（持续定位）
            'device.geolocation.stop', // 停止连续定位。
            'device.geolocation.status', // 批量连续定位状态
            'biz.map.locate', // 地图定位
            'biz.map.view', // 展示位置
            'biz.map.search', // 地图页面搜索
            'biz.util.uploadAttachment', // 上传附件到钉盘、从钉盘选择文件
            'biz.util.uploadImage', // 上传附件到钉盘、从钉盘选择文件
          ] // 必填，需要使用的jsapi列表，注意：不要带dd。
        })
        //该方法必须带上，用来捕获鉴权出现的异      
        dd.error(function (err) {
          console.error('dd error: ', err)
        }) 
      })
    }
  }
}
</script>

<style lang="less">
root {
  --van-font-size-md: 0.42rem !important;  // 默认中等字体大小
  --van-font-size-sm: 0.42rem !important;  // 小号字体
  --van-font-size-lg: 0.42rem !important;  // 大号字体
}
</style>
